import Dash from './Dash.router';

export default Dash;

export { default as dashRoutes } from './routes';
